import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FormControl, OutlinedInput, Select } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import styles from './QuantityField.module.scss';

function QuantityField({
  availableQuantities,
  disableField,
  isValidReference,
  mediaMobile = false,
  quantity,
  reference,
  setQuantity,
}: {
  availableQuantities: number[];
  disableField: boolean;
  isValidReference: boolean;
  mediaMobile?: boolean;
  quantity?: string;
  reference?: string;
  setQuantity: (qty: string) => void;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className={classnames(styles.cell, {
        [styles.mediaMobile]: mediaMobile,
      })}
      id="field-quantity"
    >
      <FormControl
        className={styles.selectInput}
        focused={false}
        variant="outlined"
      >
        <Select
          classes={{
            root: styles.selectRoot,
          }}
          displayEmpty
          disabled={!reference || !isValidReference || disableField}
          IconComponent={ExpandMoreIcon}
          id="selectQuantity"
          input={
            <OutlinedInput
              name="quantity"
              id="outlinedQuantity"
              className={
                !reference || !isValidReference || disableField
                  ? styles.disabledInput
                  : ''
              }
              classes={{
                root: styles.outlinedRoot,
                notchedOutline: styles.notchedOutline,
                disabled: styles.disabled,
              }}
            />
          }
          native
          onChange={ev => setQuantity(ev.target.value as string)}
          value={quantity}
        >
          <option className={styles.empty} value="">
            {t('LABEL_QUANTITY')}
          </option>
          {availableQuantities.map(qty => (
            <option key={qty} value={qty}>
              {qty}
            </option>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default QuantityField;
